<template>
  <div v-if="visible" class="snackbar" :style="{ backgroundColor: color }">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    color: {
      type: String,
      default: "#333" // Default color if no color is passed
    }
  },
  data() {
    return {
      visible: false,
      message: ""
    };
  },
  methods: {
    showSnackbar(msg) {
      this.message = msg;
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, 5000); // Hide snackbar after 5 seconds
    }
  }
};
</script>

<style scoped>
.snackbar {
  position: fixed;
  bottom: 20px; /* Position at the top of the page */
  left: 50%;
  transform: translateX(-50%);
  color: white; /* Text color */
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 1000;
  display: flex;
  justify-content: center; /* Horizontally center text */
  align-items: center; /* Vertically center text */
  min-height: 40px; /* Minimum height to maintain some padding */
  line-height: 1.4; /* Adjust line height to balance vertical space */
}
</style>



// WEBPACK FOOTER //
// src/components/snackbar/Snackbar.vue